




























































































































































































































































// TODO: Address this tech debt by adding proper type checking
// @ts-nocheck
import { emitEvent, AxEventType } from '@aspenware-library/event-hub'
import axios from 'axios'
import $ from 'jquery'
import * as _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

import { ProductUtils } from '@/mixins/product-utils'
import { FormManagement } from '@/mixins/form-management'
import { CartUtils } from '@/mixins/cart-utils'
import { TextFormatting } from '@/mixins/text-formatting'
import { AnalyticsTracking } from '@/mixins/analytics-tracking'
import ProductAttributes from '@/components/product-attributes.vue'
import ProductAttributesChips from '@/components/product-attributes-chips.vue'
import LoadingAnimation from '@/components/loading-animation.vue'
import { SlickShimInterface } from '../../interfaces/slick-shim.interface'
import { categoryGetters, publicUIPathGetters } from '@aspenware-library/composables'

@Component({
  name: 'productTemplate-standard',
  mixins: [ProductUtils, FormManagement, AnalyticsTracking, CartUtils, TextFormatting],
  components: {
    LoadingAnimation,
    ProductAttributes,
    ProductAttributesChips,
  },
  validations: {
    isRenewal: {
      validRenewal(value) {
        return !value
      },
    },
    productAttributes: {
      $each: {
        validRequired(value) {
          if (value.IsRequired) {
            if (value.SelectedValue || value.SelectedValueId) {
              if (value.SelectedValueId) {
                return value.SelectedValueId !== 0 // Attribute values use 0 as an unselected value.
              }
              return value.SelectedValue && value.SelectedValue.length > 0
            }
          } else {
            return true
          }

          return false
        },
      },
      validDate(value) {
        if (value) {
          const datesAsList = this.$store.getters['products/selectedProductIsRadioButtonDate']
          for (let attribute of value) {
            if (
              !datesAsList &&
              attribute.IsDate &&
              (!attribute.SelectedValueId || attribute.SelectedValueId.length < 1)
            ) {
              return false
            }
          }
        }

        return true
      },
      validActivityTime(value) {
        if (value) {
          for (let attribute of value) {
            if (attribute.IsActivityTime && (!attribute.SelectedValueId || attribute.SelectedValueId.length < 1)) {
              return false
            }
          }
        }

        return true
      },
      validListDate(value) {
        if (value) {
          var hasDate = value.some((attribute) => {
            return attribute.IsDate && attribute.SelectedValue
          })

          const datesAsList = this.$store.getters['products/selectedProductIsRadioButtonDate']
          return datesAsList ? hasDate : true
        }

        return true
      },
      validReload(value) {
        if (value) {
          var reloadSelected = this.$store.getters['products/selectedProductIsReloading']
          const selectedMemberId = this.$store.getters['products/selectedProductMemberId']

          if (reloadSelected) {
            return !!selectedMemberId
          }
        }

        return true
      },
    },
  },
})
export default class productTemplateStandard extends Vue {
  private addToCartErrorMessage = ''

  private addingToCart = false

  private attributeGroups: any = null

  private couldNotObtainLock = false

  private cssPropertyComponent = 'productDetailPage'

  private productSelectedQuantity: null

  private showChips = true

  private showErrorToast = false

  private showValidation = false

  private slickOptions: any = {
    autoplay: false,
    autoplaySpeed: 6000,
    adaptiveHeight: true,
    arrows: true,
    nextArrow: '<a class="slick-next"></a>',
    prevArrow: '<a class="slick-prev"></a>',
    accessibility: true,
    infinite: true,
    dots: true,
    customPaging: (slider, i) => {
      return '<button type="button" class="dot" data-role="none" role="button" tabindex="0">' + i + '</button>'
    },
  }

  @Getter('products/selectedProductIsRadioButtonDate') datesAsList
  @Getter('products/selectedProductMemberId') selectedMemberId
  @Getter('products/selectedProductActivityQuantityAvailable') activityQuantityAvailable
  @Getter('products/assignableMembers') assignableMembers
  @Getter('products/assignedToAttribute') assignedToAttribute
  @Getter('cart/cart') cart
  @Getter('global/currency') currency
  @Getter('global/customerSettings') customerSettings
  @Getter('products/selectedProductIsConsecutiveMultiDay') isConsecutiveMultiDay
  @Getter('products/selectedProductIsNonConsecutiveMultiDay') isNonConsecutiveMultiDay
  @Getter('global/language') language
  @Getter('global/loggingSettings') loggingSettings
  @Getter('products/selectedProduct') product
  @Getter('products/addOnAttributes') productAddOnAttributes
  @Getter('products/productAttributes') productAttributes
  @Getter('products/dateAttributes') productDateAttributes
  @Getter('products/dynamicAttributes') productDynamicAttributes
  @Getter('products/productInitialized') productInitialized
  @Getter('products/selectedProductMember') productMember
  @Getter('products/selectedProductAttributes') productSelAttributes
  @Getter('products/staticAttributes') productStaticAttributes
  @Getter('global/rentalLocationsMap') rentalLocationMap
  @Getter('products/selectedProductRentalLocations') rentalLocations
  @Getter('products/selectedProductAttributes') selectedAttributes
  @Getter('products/selectedProductDateInventory') selectedDayInventoryCount
  @Getter('products/selectedProductPaymentSchedule') selectedProductPaymentSchedule
  @Getter('products/selectedProductDate') selectedProductDate
  @Getter('products/selectedProductDates') selectedProductDates
  @Getter('products/selectedProductQuantity') selectedProductQuantity
  @Getter('products/selectedProductTime') selectedProductTime
  @Getter('cart/showCart') showCart
  @Getter('cart/showCartCard') showCartCard
  @Getter('products/productUpdating') updatingProduct
  @Getter('products/selectedProductMember') selectedProductMember

  @Action('logging/logEvent') logEvent
  @Action('logging/logMessage') logMessage
  @Action('global/sendAnalyticsPageView') sendAnalyticsPageView

  get showTitleOverCarousel(): boolean {
    const showTitleOverCarouselSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showTitleOverCarousel`
    )
    return !!(showTitleOverCarouselSetting && showTitleOverCarouselSetting === 'true')
  }

  get showImageCarousel(): boolean {
    const showImageCarouselSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showImageCarousel`
    )
    return !!(showImageCarouselSetting && showImageCarouselSetting === 'true')
  }

  get showImageCarouselArrows(): boolean {
    const showImageCarouselArrowsSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showImageCarouselArrows`
    )
    return !!(showImageCarouselArrowsSetting && showImageCarouselArrowsSetting === 'true')
  }

  get showImageCarouselDelimeters(): boolean {
    const showImageCarouselDelimetersSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showImageCarouselDelimeters`
    )
    return !!(showImageCarouselDelimetersSetting && showImageCarouselDelimetersSetting === 'true')
  }

  get cartOpen() {
    return this.cart && this.cart.showCart
  }

  get filters() {
    return this.$options.filters
  }

  get availableAddOns() {
    const addOns = this.productAddOnAttributes.filter((attr) => {
      return !attr.IsDisabled && !attr.IsHidden
    })

    let hasVisibleAddOnValues = false
    addOns.forEach((attr) => {
      const visibleAttributes = attr.Values.filter((value) => !value.IsFiltered)
      if (!_.isEmpty(visibleAttributes)) {
        hasVisibleAddOnValues = true
      }
    })

    const hasAvailableAddons = !_.isEmpty(addOns) && hasVisibleAddOnValues

    return hasAvailableAddons ? addOns : null
  }

  get availableProductQuantities() {
    const activityQuantityAvailable = this.activityQuantityAvailable
    let quantities = this.productQuantities.map((item) => {
      let isHidden = false
      if (activityQuantityAvailable !== null) {
        isHidden = parseInt(item.Value) > activityQuantityAvailable
      }
      return {
        value: item.Value,
        name: item.Text,
        hidden: isHidden,
        isPreSelected: item.Selected,
      }
    })

    //filtering the out quantities larger than whats in inventory
    const selectedDayInventoryCount = this.selectedDayInventoryCount
    if (selectedDayInventoryCount !== null) {
      quantities = quantities.filter((item) => {
        return parseInt(item.value) <= selectedDayInventoryCount
      })
    }
    return quantities
  }

  get assignableMembersLoaded() {
    return this.assignableMembers && this.assignableMembers.length > 0
  }

  get displayRFID() {
    return this.customerSettings && this.customerSettings.DisplayRFID
  }

  get showNumberOfDaysToSelect() {
    return (
      this.isNonConsecutiveMultiDay &&
      !this.isConsecutiveMultiDay &&
      !this.datesAsList &&
      this.productNumberOfDays &&
      this.productNumberOfDays > 1
    )
  }

  get locale() {
    return this.language
  }

  get productHasQuantities() {
    const availableQuantities = this.availableProductQuantities.filter((quantity) => {
      return !quantity.hidden
    })
    return !_.isEmpty(this.productQuantities) && !_.isEmpty(availableQuantities)
  }

  get productNumberOfDays() {
    var selectedProductDayCount = this.$store.getters['products/selectedProductNumberOfDays']
      ? this.$store.getters['products/selectedProductNumberOfDays']
      : null

    if (selectedProductDayCount) {
      // Calculate the number of days remaining to select
      var selectedDates = this.$store.getters['products/selectedProductDates']
        ? this.$store.getters['products/selectedProductDates'].length
        : 0
      return selectedProductDayCount - selectedDates
    } else {
      return null
    }
  }

  get productPhotos() {
    var photoset: any[] = []
    if (this.product) {
      photoset = _.filter(this.product.PictureModels, function (o) {
        return o.Title.toUpperCase() !== 'ICON'
      })
    }
    return photoset
  }

  get productQuantities() {
    return this.product ? this.product.AddToCart.AllowedQuantities : []
  }

  get showQuantityMessage() {
    return (
      this.$store.getters['products/selectedProductDateRules'] &&
      this.$store.getters['products/selectedProductDateRules'].indexOf('lowInventory') > -1
    )
  }

  get hideDynamicPrice() {
    return this.isDynamicPricing && !this.product.DynamicPriceSet
  }

  get selectedAttributesForDisplay() {
    return _.filter(this.selectedAttributes, function (attr) {
      return !attr.IsDate && !attr.Disabled
    })
  }

  get productPrice() {
    var price = this.$store.getters['products/selectedProductPrice']
    if (price && _.endsWith(price, '.00')) {
      price = price.substring(0, price.length - 3)
    }
    return price
  }

  get selectedMemberMaskedMediaNumber() {
    var selectedMember = this.$store.getters['products/selectedProductMember']
    if (selectedMember) {
      var passMediaNumber = selectedMember.PassMediaNumber
      return passMediaNumber.substr(0, passMediaNumber.length - 4) + 'XXXX'
    }
    return null
  }

  get category() {
    return this.$store.getters['products/category']
  }

  get categoryName() {
    return this.category ? this.category.Name : null
  }

  get isDynamicPricing() {
    return this.product.IsDynamicPriceDaysToArrival ? this.product.IsDynamicPriceDaysToArrival : false
  }

  get isRenewal() {
    return this.product ? this.product.IsRenewal : false
  }

  get isReservationProduct() {
    return this.product ? this.product.IsReservationProduct : false
  }

  get labels() {
    return this.$store.getters['global/labels'].ShoppingCart
  }

  @Watch('productMember')
  onProductMemberChanged(toMember) {
    if (toMember && toMember.ContactInfoId) {
      this.assignedToAttribute.SelectedValue = toMember.ContactInfoId
    }
  }

  @Watch('productInitialized')
  onProductInitializedChanged() {
    this.showValidation = this.productInitialized
  }

  @Watch('selectedProductQuantity')
  onSelectedProductQuantity(toValue) {
    this.$set(this, 'productSelectedQuantity', toValue)
  }

  @Watch('showCart')
  onShowCardChanged(toValue) {
    if (toValue) {
      this.toggleCartCard()
    }
  }

  mounted() {
    if (this.$route.query && this.$route.query.showZones === 'true') {
      ;(this.$refs.ProductDetail as HTMLElement).classList.add('show-zones')
    }
    this.fetchAttributeGroups()
    this.$store.dispatch('products/loadProductDetails')
    const root = document.getElementsByTagName('html')[0] as HTMLElement
    root.classList.add('html-product-detail-page')
    root.classList.remove('html-category-page', 'html-product-calendar-page')

    this.sendAnalyticsPageView({
      path: this.$route.path,
      title: this.product.Name,
    })

    this.logProductView()
  }

  fetchAttributeGroups() {
    axios.get(`/api/AttributeGroups/${this.product.Id}`).then((groups) => {
      this.attributeGroups = groups.data
    })
  }

  logProductView() {
    // Only do this if the current category ID should initiate a session
    const startLoggingProductIds = this.loggingSettings.StartProductIds.split(',')
    const startLoggingNow = startLoggingProductIds.includes(this.product.Id.toString())

    if (this.category) {
      this.logEvent({
        event: `view-product--${this.category.Id}`,
        startLogging: startLoggingNow,
      })
    }
  }

  recordUserInteraction() {
    this.$set(this, 'couldNotObtainLock', false)
  }

  quantityChanged(newValue) {
    this.$store.dispatch('products/updateProductFilteredValues')
    this.$store.dispatch('products/updateProductAttributes', false)
    this.$store.commit('products/setProductQuantity', newValue)
  }

  toggleCartCard() {
    this.$store.dispatch('cart/toggleCartCard')
    if (this.showCartCard && this.$refs.detailSummaryBarWrapper) {
      ;(this.$refs.detailSummaryBarWrapper as HTMLElement).classList.add('open')
    }
  }

  onMemberSelected(member) {
    this.$store.dispatch('products/assignSelectedProduct', member)
    this.$store.dispatch('products/setSelectedMemberReservations', member.ContactInfoId)
  }

  initials(member) {
    var initials = ''
    initials += member.FirstName.charAt(0)
    initials += member.LastName.charAt(0)
    return initials
  }

  backToCategory() {
    // Reset the slider position for products to the first image
    var currentCategory = this.$route.params.category
    var currentSubcategory = this.$route.params.subcategory
    $('html').removeClass('html-product-detail-page')
    $('html').addClass('html-category-page')
    this.toggleCartCard()

    if (this.category && this.category.ShowPricingCalendar) {
      if (window.storeSettings.CloudEnabled && !this.category.UseLegacy) {
        window.location.href = publicUIPathGetters.getFullPageCalendarPath(
          currentCategory,
          currentSubcategory,
          this.category.PricingCalendarProduct
        )
      } else {
        this.$router.push({
          name: 'product-pricing-calendar',
          params: {
            category: currentCategory,
            subcategory: currentSubcategory,
            product: this.category.PricingCalendarProduct,
          },
        })
      }
    } else {
      this.$store.dispatch('products/resetSelectedProductDefaults')
      this.$store.dispatch('products/clearSelectedProduct')
      if (window.storeSettings.CloudEnabled && !this.category.UseLegacy) {
        window.location.href = categoryGetters.getCategoryLink({ category: this.category })
      } else {
        this.$router.push({
          name: 'product-category',
          params: { category: currentCategory, subcategory: currentSubcategory },
        })
      }
    }
  }

  resetProduct() {
    _.delay(() => {
      if (this.productPhotoSliderInstance) {
        this.productPhotoSliderInstance.slick.slickGoTo(0, true)
      }
    }, 350)
  }

  resetFilteredAttributes() {
    var self = this

    var filteredAttributes = _.filter(
      self.$store.getters['products/selectedProduct'].ProductAttributes,
      function (attr) {
        return attr.Configuration && attr.Configuration.filterBy
      }
    )
    _.each(filteredAttributes, function (attr) {
      var filter = _.find(self.$store.getters['products/selectedProductFilters'], function (f) {
        return attr.Configuration.filterBy.name === f.name
      })
      var filterRegex = new RegExp(attr.Configuration.filterBy.match)
      var match = filterRegex.exec(attr.SelectedValue)
      if (match && match.length > 0) {
        var matchValue = match[0]
        if (matchValue !== filter.value) {
          attr.SelectedValue = null
        }
      }
    })
  }

  broadcastAddToCartEvent(productId) {
    emitEvent(AxEventType.AddToCart, { productId: productId })
  }

  async addToCart(event) {
    this.addingToCart = true

    this.$store.dispatch('cart/persistTempGA4Data', { id: 'category_products', name: 'Category Products' })
    if (this.product.IsActivity) {
      const selectedTimeHour = this.selectedProductTime.split(':')[0]
      const selectedTimeMinutes = this.selectedProductTime.split(':')[1]
      const selectedDate = this.selectedProductDate
      const selectedMonth = _.padStart(selectedDate.getMonth() + 1, 2, '0')
      const selectedDay = _.padStart(selectedDate.getDate(), 2, '0')
      const lockDateTime = `${selectedDate.getFullYear()}-${selectedMonth}-${selectedDay}T${selectedTimeHour}:${selectedTimeMinutes}:00`
      const lockRequest = {
        activityCode: this.product.Activity.Code,
        activityLocationCode: this.product.Activity.Location,
        activityDateTime: lockDateTime,
        quantity: this.selectedProductQuantity,
        productHeaderCode: this.product.ProductHeaderCode,
      }

      const lockData = await this.$store.dispatch('activities/requestLock', lockRequest)

      if (lockData && lockData.Locks) {
        await this.$store.dispatch('products/updateActivityLockId', lockData.Locks[0].MasterLockId)

        const result = await this.$store.dispatch('cart/addToCart', {
          productId: this.product.Id,
          productAttributes: this.product.ProductAttributes,
          productQuantity: this.selectedProductQuantity,
        })

        // Refresh cart data
        this.getCartData(null, true, () => {
          this.onCartReload()
          if (result.success) this.$store.dispatch('cart/saveAndSendGA4AddToCartEvent')
        })
      } else {
        // A lock could not be obtained
        this.addingToCart = false
        this.couldNotObtainLock = true
      }
    } else {
      const cartPayload = {
        productId: this.product.Id,
        productAttributes: this.product.ProductAttributes,
        productQuantity: this.selectedProductQuantity,
      }
      const result = await this.$store.dispatch('cart/addToCart', cartPayload)
      if (result.success === false) {
        this.addToCartErrorMessage = result.message.toString()
        this.showErrorToast = true
      } else {
        this.broadcastAddToCartEvent(this.product.Id)
      }

      // Refresh cart data
      this.getCartData(null, true, () => {
        this.onCartReload()
        if (result.success) this.$store.dispatch('cart/saveAndSendGA4AddToCartEvent')
      })

      // Second call to get assignable contacts after cart changes occure
      const assignableContactsResponse = await this.$store.dispatch('products/updateProductAssignableMembers', {
        forceUpdate: true,
      })
    }
  }

  onCartReload() {
    var scrollToElement = $('#commerce-store')
    var container = $('body, html')
    this.resetProduct()
    this.addingToCart = false

    if (container && scrollToElement) {
      container.animate({
        scrollTop: scrollToElement.offset()?.top,
      })
    }

    if (!this.isReservationProduct) {
      this.$store.dispatch('products/clearProductAssignment')
    }
  }

  refreshSlider() {
    // This code is required to refresh the slider view when on-page resizing might change slider display. Without it, slides may only be partially viewable.
    if (this.productPhotoSliderInstance) {
      this.productPhotoSliderInstance.slick.slickSetOption('infinite', true, true)
      const currentSlide = this.productPhotoSliderInstance.slick.slickCurrentSlide()
      // This delay is required to allow for page animations that may affect the slider container width to complete
      _.delay(() => {
        this.productPhotoSliderInstance.slickGoTo(currentSlide, true)
      }, 500)
    }
  }

  clearProductAssignment() {
    this.$store.dispatch('products/clearProductAssignment')
  }

  loadMembers(update) {
    const refreshMembers = update ? update : false
    this.$store.dispatch('products/updateProductAssignableMembers', { forceUpdate: refreshMembers })
  }

  private get productPhotoSliderInstance(): Vue & SlickShimInterface {
    return this.$refs.productPhotoSlider as Vue & SlickShimInterface
  }
}
